import {Outlet, useOutletContext} from 'react-router-dom'
import {useAuthStore} from '@/features/auth/store/store'
import {NoPermissionBox} from '@/components/commons/no-permission-box/NoPermissionBox'
import {ProjectExtended} from '@/features/projects/types'

export const ProjectDetailsLogsRoute = () => {
    const roleName = useAuthStore(state => state.user?.roleName)
    const context = useOutletContext<{project: ProjectExtended; isEditable: boolean}>()

    if (roleName !== 'Admin') {
        return <NoPermissionBox />
    }

    return <Outlet context={context} />
}
